import { Controller } from "react-hook-form";
import { Label, RadioGroup, RadioGroupItem } from "@/components/ui";
import { FormRadioGroupProps } from "./types";

const FormRadioGroup = ({
  name,
  control,
  options,
  disabled = false,
}: FormRadioGroupProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          value={value}
          onValueChange={onChange}
          disabled={disabled}
          className="ml-1 flex flex-row items-center gap-5"
        >
          {options?.map((data) => {
            const isSelected = value === data?.value;
            return (
              <div key={data?.value} className="flex flex-row items-center gap-1">
                <RadioGroupItem
                  value={data?.value}
                  id={`${name}-${data?.value}`}
                  className={isSelected ? "border-primary" : ""}
                />
                <Label htmlFor={`${name}-${data?.value}`} className="font-normal cursor-pointer">
                  {data?.label}
                </Label>
              </div>
            );
          })}
        </RadioGroup>
      )}
    />
  );
};

export default FormRadioGroup;